export default "__VITE_ASSET__9ac25fae__"